import { render, staticRenderFns } from "./VerificationEmail.vue?vue&type=template&id=a0cb5f90&scoped=true"
import script from "./VerificationEmail.vue?vue&type=script&lang=js"
export * from "./VerificationEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb5f90",
  null
  
)

export default component.exports